import React, { useState, useEffect }from 'react';
import { useParams } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import Slider from 'react-slick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft} from '@fortawesome/free-solid-svg-icons';
import { motion } from "framer-motion";
import useModal from '../../hooks/useModal'
import Modal from '../../components/ui/Modal';



const Detail = ({ item, table_list, type }) => {
  const { postId } = useParams();
  const [startY, setStartY] = useState(0);
  const [Dragging, setDragging] = useState(false)
  const [direction, setDirection] = useState("")
  const images = document.querySelectorAll('.detail__img-img');
  const [isPC, setIsPC] = useState(window.innerWidth > 768);
  const { isOpen, openModal, closeModal } = useModal();
  const [currentPage, setCurrentPage] = useState("");
  const backUrl = process.env.REACT_APP_API_URL;


  
  useEffect(() => {
    const handleResize = () => {
      setIsPC(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const CustomArrow = ({ className, style, onClick, direction }) => (
    <button
      className={className}
      style={{
        ...style,
        borderRadius: '50%',
        zIndex: 10,
        left: direction === 'prev' ? '10px' : 'auto',
        right: direction === 'next' ? '10px' : 'auto',
      }}
      onClick={onClick}
    >
    <FontAwesomeIcon 
      icon={direction === 'prev' ? faChevronLeft : faChevronRight} 
      style={{
        color: '#fff',
        fontSize: '10px', // アイコンのサイズを指定
      }} 
    />
    </button>
  );
  const settings = {
    dots: true,  // ドットナビ
    nextArrow: <CustomArrow direction="next" />,
    prevArrow: <CustomArrow direction="prev" />,
    autoplay: true,  // 自動スライドを有効化
    autoplaySpeed: 3000,  // 3秒ごとにスライド切り替え
  };
  const hasImages = item?.images?.length > 0;
  const hasEquipment = item?.equipment?.length > 0;
  const hasUser_image = item?.User_image?.length > 0;
  const hasUser_line_image = item?.User_line_image?.length > 0;
  const isTransaction = type  === "transaction"
  const Isidentification = item?.User_identification === '1'

  const googleMapUrl = `https://www.google.com/maps?q=${encodeURIComponent(item.address)}`;


  const creatChatID = () => {
    const token = localStorage.getItem('token');
    if(token){
      const loginUserId = localStorage.getItem('userid');
      const postUserId = item.User;

      const generateChatRoomId = (loginUserId, postUserId) => {
        const minUserId = Math.min(loginUserId, postUserId)
        const maxUserId = Math.max(loginUserId, postUserId)
        const roomString = `${minUserId}_${maxUserId}`;
        return {
          chatRoomId: CryptoJS.SHA256(roomString).toString(CryptoJS.enc.Hex),
          minUserId,
          maxUserId
        };
      };
      // const token = localStorage.getItem('token');
      const { chatRoomId, minUserId, maxUserId } = generateChatRoomId(loginUserId, postUserId);

      window.location.href = `/chat/${chatRoomId}/${minUserId}/${maxUserId}/`;
    }else{
      setCurrentPage("404-login");
      openModal();
    }
  };

  
  return (
    <>
    <div className={hasImages? 'detail' :'detail noimage' }>
      {hasImages && !isPC ? (
      <>
      <div className='detail__img-wrap'>
        <div className="detail__img" >
          {item.images.length > 1 ? (
            <Slider {...settings}>
              {item.images.map((image) => (
                <img
                  className="detail__img-img"
                  key={image.id}
                  src={`${backUrl}${image.image}`}
                  alt={`${image.id}`}
                />
                
              ))}
            </Slider>
          ) : (
            <img
              className="detail__img-img"
              src={`${backUrl}${item.images[0].image}`}
              alt={`${item.images[0].id}`}
            />
          )}
        </div>
      </div>

      <motion.div
        drag="y"  // ドラッグ可能にする
        initial={{ y: 0 }} 
        animate={{ y: direction==="up" ? -200: 0  }}
        dragConstraints={{ top: 30, bottom: 0}} // ドラッグ範囲を制限
        transition={{ type: "spring", stiffness: 150, damping: 25 }}
        onDragStart={(event, info) => {
          setStartY(info.point.y);
          setDragging(true)
        }}
        onDragEnd={(event, info) => {
          console.log("ドラッグ終了:", info.point);
          setDragging(false)
          if (info.point.y > startY) {
            setDirection("down");
            images.forEach(image => {
              image.classList.remove('shrink');
            });
          } else if (info.point.y < startY) {
            setDirection("up"); 
            images.forEach(image => {
              image.classList.add('shrink');
            });
          } 
        }}
        style={{
          width: '100%',
          // height: '100px',
          position: 'absolute',
          cursor: 'grab',
          margin:'-130px 0 0',
          backgroundColor:"#F8F6F1",
          borderRadius: "20px",
        }}
      >
        <div className="detail__cont" id="content">
        <div className='detail__cont-tab'></div>
        <div className='detail__cont-name'>
          {hasUser_image ? (
            <img src={`${backUrl}/media/${item.User_image}`} alt="User Image" />
          ): hasUser_line_image && hasUser_line_image !== 'None' ? (
            <img src={`${item.User_line_image}`} alt="User Image" />
          ):(
            <img src='/media/none_user.svg' alt="User Image" />
          )}
          <span className='detail__cont-name-user'>{item.User_name}</span>

          {Isidentification ? (
            <span className='detail__cont-name-conf'>認証済</span>
          ):(
            <span className='detail__cont-name-conf'>未認証</span>
          )}
        </div>
        <div className='detail__cont-ttl'>
          <h3>{item.title}</h3>
          {isTransaction &&(
          <h3>$ {item.cost}</h3>
          )}
        </div>
        <div className='detail__cont-map'>
          <p className='green'>{item.address}</p>
          <a href={googleMapUrl} target="_blank">
            <p className='orange'>　MAPで見る</p>
          </a>
        </div>
        <table className='detail__cont-cat'>
          {Object.entries(table_list).map(([key, value]) => (
            <tr key={key}>
              <td>{key}</td>
              {value === 'ー' ? (
                <td className="none">{value}</td>
              ) : (
                <td>{value}</td>
              )}
            </tr>
          ))}
        </table>
        <div className='detail__cont-cont' style={{ whiteSpace: "pre-wrap"}}>
          <p>{item.content}</p>
        </div>
        {hasEquipment &&(
        <div className='detail__cont-equipment'>
          {item.equipment.map((equipments) => (
            <span>{equipments.name}</span>
          ))}
        </div>
        )}
      </div>
      </motion.div>
      </>
    ):(
      <div className='detail__wrap'>
        {hasImages &&( 
        <div className='detail__img-wrap'>
          <div className="detail__img" >
            {item.images.length > 1 ? (
              <Slider {...settings}>
                {item.images.map((image) => (
                  <img
                    className="detail__img-img"
                    key={image.id}
                    src={`${backUrl}/${image.image}`}
                    alt={`${image.id}`}
                  />
                  
                ))}
              </Slider>
            ) : (
              <img
                className="detail__img-img"
                src={`${backUrl}/${item.images[0].image}`}
                alt={`${item.images[0].id}`}
              />
            )}
          </div>
        </div>
        )}
        <div className="detail__cont noimage " id="content">
          <div className='detail__cont-name noimage'>
            {hasUser_image ? (
              <img src={`${backUrl}/media/${item.User_image}`} alt="User Image" />
            ): hasUser_line_image && hasUser_line_image !== 'None' ? (
              <img src={`${item.User_line_image}`} alt="User Image" />
            ):(
              <img src='/media/none_user.svg' alt="User Image" />
            )}
            <span className='detail__cont-name-user'>{item.User_name}</span>
            {Isidentification ? (
              <span className='detail__cont-name-conf'>認証済</span>
            ):(
              <span className='detail__cont-name-conf'>未認証</span>
            )}
          </div>
          <div className='detail__cont-ttl'>
            <h3>{item.title}</h3>
            {isTransaction &&(
            <h3>$ {item.cost}</h3>
            )}
          </div>
          <div className='detail__cont-map'>
            <p className='green'>{item.address}</p>
            <a href={googleMapUrl} target="_blank">
              <p className='orange'>　MAPで見る</p>
            </a>
          </div>
          <table className='detail__cont-cat'>
            {Object.entries(table_list).map(([key, value]) => (
              <tr key={key}>
                <td>{key}</td>
                {value === 'ー' ? (
                  <td className="none">{value}</td>
                ) : (
                  <td>{value}</td>
                )}
              </tr>
            ))}
          </table>
          <div className='detail__cont-cont' style={{ whiteSpace: "pre-wrap"}}>
          <p>{item.content}</p>
        </div>
        {hasEquipment &&(
        <div className='detail__cont-equipment'>
          {item.equipment.map((equipments) => (
            <span>{equipments.name}</span>
          ))}
        </div>
        )}
      </div>
    </div>
    )}
    
    <div className='detail__btn'>
      {/* <button>一覧へ戻る</button> */}
      <button id="chat-room-btn" onClick={creatChatID} style={{fontSize:'12px'}}>HAVE CHAT<br /><span>タイトルを入力していただくとスムーズです</span></button>
    </div>
  </div> 
  <Modal 
    isOpen={isOpen} 
    closeModal={closeModal} 
    currentPage={currentPage} 
    setCurrentPage={setCurrentPage} 
    className="login"
    >
  </Modal>
  </>
  );
};

export default Detail;